import React from 'react';

import { required } from '../../util/validators';
import { FieldSelect } from '../../components';

import css from './EditProductForm.css';

const CustomCategorySelectFieldMaybe = props => {
  const { name, id, categories, intl, form, markRequired } = props;
  const categoryLabel = intl.formatMessage({
    id: 'EditListingDescriptionForm.categoryLabel',
  });
  const categoryPlaceholder = intl.formatMessage({
    id: 'EditListingDescriptionForm.categoryPlaceholder',
  });
  const categoryRequired = required(
    intl.formatMessage({
      id: 'EditListingDescriptionForm.categoryRequired',
    })
  );

  const handelChange = (event) => {
    form.change('category', event.target.value);
    form.change('businessCategory', '');
  }

  return categories ? (
    <FieldSelect
      className={css.category}
      name={name}
      id={id}
      label={categoryLabel}
      validate={categoryRequired}
      onChange={handelChange}
      markRequired={markRequired}
    >
      <option disabled value="">
        {categoryPlaceholder}
      </option>
      {categories.map(c => (
        <option key={c.key} value={c.key}>
          {intl.formatMessage({id: c.translation})}
        </option>
      ))}
    </FieldSelect>
  ) : null;
};

export default CustomCategorySelectFieldMaybe;
